(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ib-all-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  var wrap = document.querySelector('.iar-wrap');
  if (!wrap) return;
  var grid = wrap.querySelector('.iar-grid');
  var btn = wrap.querySelector('.iar-more');
  var progress = wrap.querySelector('.iar-progress');
  var shop = wrap.dataset.shop;
  var perLoad = parseInt(wrap.dataset.perLoad, 10) || 10;
  var minRating = parseInt(wrap.dataset.minRating, 10) || 0;
  var totalAll = 0; // learned from the API (filtered count); raw store total includes hidden 1–2★
 
  var shown = {};
  grid.querySelectorAll('.iar-card').forEach(function(c){ shown[c.dataset.uuid] = true; });
  var buffer = [];
  var nextPage = 1;
  var totalPages = 999;
  var exhausted = false;
 
  function esc(s){ var d=document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function stars(r){ var h=''; for(var i=1;i<=5;i++){ h += '<span class="iar-star'+(i>r?' iar-star--off':'')+'">★</span>'; } return h; }
  function fmtDate(iso){
    try{ return new Date(iso).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}); }catch(e){ return ''; }
  }
 
  function cardHTML(rv){
    var h = '<div class="iar-card__top">'
      + '<span class="iar-avatar">'+esc((rv.reviewer_initial||'?'))+'</span>'
      + '<div class="iar-card__meta"><div class="iar-card__author-row">'
      + '<span class="iar-card__author">'+esc(rv.reviewer_name||'Anonymous')+'</span>'
      + (rv.verified_buyer ? '<span class="iar-verified">✓ VERIFIED</span>' : '')
      + '</div><div class="iar-card__stars">'+stars(rv.rating)+'</div></div>'
      + '<span class="iar-card__date">'+fmtDate(rv.created_at)+'</span></div>';
    if (rv.title) h += '<h3 class="iar-card__title">'+esc(rv.title)+'</h3>';
    h += '<div class="iar-card__body">'+(rv.body_html || '<p>'+esc(rv.body)+'</p>')+'</div>';
    if (rv.pictures_urls && rv.pictures_urls.length){
      h += '<div class="iar-card__pics">';
      rv.pictures_urls.slice(0,4).forEach(function(p){
        h += '<a href="'+esc(p.original)+'" target="_blank" rel="noopener nofollow"><img src="'+esc(p.small)+'" loading="lazy" alt="Customer photo"></a>';
      });
      h += '</div>';
    }
    if (rv.product_title){
      h += '<div class="iar-card__prod">'
        + (rv.product_in_store && rv.product_url ? '<a href="'+esc(rv.product_url)+'">'+rv.product_title+'</a>' : '<span>'+rv.product_title+'</span>')
        + '</div>';
    }
    return h;
  }
 
  function appendReview(rv){
    var el = document.createElement('article');
    el.className = 'iar-card';
    el.dataset.uuid = rv.uuid;
    el.innerHTML = cardHTML(rv);
    grid.appendChild(el);
    shown[rv.uuid] = true;
  }
 
  function fetchPage(page){
    var u = 'https://cdn.judge.me/widgets/reviews_grid_widget_data'
      + '?shop_domain=' + encodeURIComponent(shop)
      + '&platform=shopify&review_selection=all&page=' + page;
    // Only pull ratings >= minRating (e.g. 3,4,5). Client filter below is a fallback.
    if (minRating > 0) {
      for (var r = minRating; r <= 5; r++) u += '&filter_rating[]=' + r;
    }
    return fetch(u).then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); });
  }
 
  function fillBuffer(need){
    if (buffer.length >= need || exhausted || nextPage > totalPages) return Promise.resolve();
    return fetchPage(nextPage).then(function(data){
      totalPages = data.total_pages || totalPages;
      if (data.total_count) totalAll = data.total_count;
      nextPage++;
      var got = data.reviews || [];
      if (!got.length) { exhausted = true; return; }
      got.forEach(function(rv){
        if (shown[rv.uuid]) return;
        if (minRating > 0 && rv.rating < minRating) return;
        if (buffer.some(function(b){ return b.uuid === rv.uuid; })) return;
        buffer.push(rv);
      });
      if (nextPage > totalPages) exhausted = true;
      return fillBuffer(need);
    });
  }
 
  function updateUI(){
    var count = grid.querySelectorAll('.iar-card').length;
    if (progress) progress.textContent = totalAll > 0
      ? ('SHOWING ' + count + ' OF ' + totalAll + ' REVIEWS')
      : ('SHOWING ' + count + ' REVIEWS');
    if ((exhausted && !buffer.length) || (totalAll > 0 && count >= totalAll)) btn.classList.add('iar-more--hidden');
  }
 
  btn.addEventListener('click', function(){
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'LOADING…';
    fillBuffer(perLoad).then(function(){
      buffer.splice(0, perLoad).forEach(appendReview);
      updateUI();
    }).catch(function(){
      exhausted = false;
      btn.textContent = 'TRY AGAIN';
      setTimeout(function(){ btn.textContent = label; }, 1600);
    }).finally(function(){
      btn.disabled = false;
      if (btn.textContent === 'LOADING…') btn.textContent = label;
    });
  });
 
  updateUI();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iron-new-arrivals"] && !Shopify.designMode) return;
  try {
    
(function(){
  function openCartDrawer() {
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        if (sections['cart-icon-bubble']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-icon-bubble'];
          var freshBubble = tmp.querySelector('#cart-icon-bubble');
          var existBubble = document.querySelector('#cart-icon-bubble');
          if (freshBubble && existBubble) existBubble.innerHTML = freshBubble.innerHTML;
        }
        if (sections['cart-drawer']) {
          var tmp2 = document.createElement('div');
          tmp2.innerHTML = sections['cart-drawer'];
          var freshDrawer = tmp2.querySelector('#CartDrawer');
          var existDrawer = document.querySelector('#CartDrawer');
          if (freshDrawer && existDrawer) existDrawer.innerHTML = freshDrawer.innerHTML;
        }
      })
      .catch(function() {})
      .finally(function() {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          var cartBtn = document.querySelector('#cart-icon-bubble, [aria-controls="CartDrawer"], .header__icon--cart');
          if (cartBtn) cartBtn.click();
        }
      });
  }

  function handleAddToCart(btn) {
    var id = btn.dataset.variantId;
    if (!id || btn.classList.contains('is-adding')) return;
    btn.classList.add('is-adding');
    btn.textContent = 'ADDING...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || 'Error'); });
      return r.json();
    })
    .then(function() {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.textContent = '✓ ADDED';
      openCartDrawer();
      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.textContent = 'ADD TO CART';
      }, 2200);
    })
    .catch(function(err) {
      btn.classList.remove('is-adding');
      btn.textContent = err.message || 'TRY AGAIN';
      setTimeout(function() { btn.textContent = 'ADD TO CART'; }, 2000);
    });
  }

  document.querySelectorAll('.ina-slider-wrap').forEach(function(wrap) {
    var grid = wrap.querySelector('.ina-grid');
    var prev = wrap.querySelector('.ina-nav--prev');
    var next = wrap.querySelector('.ina-nav--next');
    if (!grid || !prev || !next) return;

    function updateNav() {
      var atStart = grid.scrollLeft <= 4;
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
      prev.classList.toggle('ina-nav--hidden', atStart);
      next.classList.toggle('ina-nav--hidden', atEnd);
    }

    function scrollBy(dir) {
      var card = grid.querySelector('.ina-card');
      var step = card ? card.offsetWidth + 12 : grid.clientWidth * 0.8;
      grid.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    prev.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); scrollBy(-1); });
    next.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); scrollBy(1); });
    grid.addEventListener('scroll', updateNav, { passive: true });
    updateNav();
  });

  document.addEventListener('click', function(e) {
    var cartBtn = e.target.closest('.ina-overlay-btn--cart');
    if (cartBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleAddToCart(cartBtn);
      return;
    }
    var quickBtn = e.target.closest('.ina-overlay-btn--quick');
    if (quickBtn) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = quickBtn.dataset.url;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iron-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-iron-pdp]').forEach(function(root){
    var stage = root.querySelector('[data-stage]');
    var slides = Array.from(root.querySelectorAll('[data-slide]'));
    var thumbs = root.querySelectorAll('[data-thumb]');
    var dots   = root.querySelectorAll('[data-dot]');
    var counter = root.querySelector('[data-counter]');
    var total = slides.length;
    var curIdx = 0;

    function show(i){
      curIdx = ((i % total) + total) % total;
      slides.forEach(function(s,n){ s.classList.toggle('is-active', n===curIdx); });
      thumbs.forEach(function(t,n){ t.classList.toggle('is-active', n===curIdx); });
      dots.forEach(function(d,n){ d.classList.toggle('is-active', n===curIdx); });
      if(counter) counter.textContent = (curIdx+1)+' / '+total;
      stage.classList.remove('is-zoom');
      if(lb && !lb.hidden) renderLb();
    }

    root.querySelectorAll('[data-prev]').forEach(function(b){ b.addEventListener('click', function(){ show(curIdx-1); }); });
    root.querySelectorAll('[data-next]').forEach(function(b){ b.addEventListener('click', function(){ show(curIdx+1); }); });
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ show(+t.dataset.index); }); });
    dots.forEach(function(d){ d.addEventListener('click', function(){ show(+d.dataset.index); }); });

    stage.addEventListener('mousemove', function(e){
      var img = slides[curIdx].querySelector('[data-zoomable]'); if(!img) return;
      var r = stage.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%';
    });
    stage.addEventListener('click', function(e){
      if(e.target.closest('button')) return;
      if(!slides[curIdx].querySelector('[data-zoomable]')) return;
      stage.classList.toggle('is-zoom');
    });

    var sx=null;
    stage.addEventListener('touchstart',function(e){ sx=e.touches[0].clientX; },{passive:true});
    stage.addEventListener('touchend',function(e){
      if(sx===null) return; var d=e.changedTouches[0].clientX-sx;
      if(d<-45) show(curIdx+1); else if(d>45) show(curIdx-1); sx=null;
    });

    // Lightbox
    var lb = root.querySelector('[data-lightbox]');
    var lbStage = root.querySelector('[data-lb-stage]');
    var lbCounter = root.querySelector('[data-lb-counter]');
    function renderLb(){
      var node = slides[curIdx].cloneNode(true);
      lbStage.innerHTML=''; while(node.firstChild) lbStage.appendChild(node.firstChild);
      if(lbCounter) lbCounter.textContent=(curIdx+1)+' / '+total;
    }
    var lbOpen = root.querySelector('[data-lightbox-open]');
    if(lbOpen) lbOpen.addEventListener('click',function(){ lb.hidden=false; renderLb(); document.body.style.overflow='hidden'; });
    root.querySelector('[data-lightbox-close]').addEventListener('click',function(){ lb.hidden=true; document.body.style.overflow=''; });
    document.addEventListener('keydown',function(e){
      if(lb.hidden) return;
      if(e.key==='Escape'){ lb.hidden=true; document.body.style.overflow=''; }
      if(e.key==='ArrowRight') show(curIdx+1);
      if(e.key==='ArrowLeft') show(curIdx-1);
    });

    // Quantity stepper
    var qty = 1;
    var qtyDisplay = root.querySelector('[data-qty-display]');
    var stickyQtyDisplay = root.querySelector('[data-sticky-qty-display]');
    function updateQty(n){
      qty = Math.max(1, Math.min(99, n));
      if(qtyDisplay) qtyDisplay.textContent = qty;
      if(stickyQtyDisplay) stickyQtyDisplay.textContent = qty;
      var hiddenQty = root.querySelector('input[name="quantity"]');
      if(hiddenQty) hiddenQty.value = qty;
    }
    var decBtn = root.querySelector('[data-qty-dec]');
    var incBtn = root.querySelector('[data-qty-inc]');
    if(decBtn) decBtn.addEventListener('click', function(){ updateQty(qty-1); });
    if(incBtn) incBtn.addEventListener('click', function(){ updateQty(qty+1); });

    // Add quantity input to form
    var form = root.querySelector('#iron-form');
    if(form){
      var qInput = document.createElement('input');
      qInput.type='hidden'; qInput.name='quantity'; qInput.value='1';
      form.appendChild(qInput);
    }

    // Variants
    var varData = root.querySelector('[data-iron-variants]');
    var variants = varData ? JSON.parse(varData.textContent) : [];
    var selected = {};
    root.querySelectorAll('[data-opt-value]').forEach(function(btn){
      if(btn.classList.contains('is-selected')) selected[btn.dataset.optPosition]=btn.dataset.value;
      btn.addEventListener('click',function(){
        var pos=btn.dataset.optPosition;
        root.querySelectorAll('[data-opt-value][data-opt-position="'+pos+'"]').forEach(function(b){ b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selected[pos]=btn.dataset.value;
        var lbl=root.querySelector('[data-opt-current="'+(+pos-1)+'"]'); if(lbl) lbl.textContent=btn.dataset.value;
        syncVariant();
      });
    });
    function syncVariant(){
      var match=variants.find(function(v){ return v.options.every(function(o,i){ return o===selected[String(i+1)]; }); });
      if(!match) return;
      root.querySelector('[data-variant-id]').value=match.id;
      root.querySelectorAll('[data-price],[data-price-cta],[data-sticky-price]').forEach(function(el){ el.textContent=match.price; });
      var sOpts=root.querySelector('[data-sticky-opts]'); if(sOpts) sOpts.textContent=match.title;
      var addBtn=root.querySelector('[data-add]'); if(addBtn) addBtn.disabled=!match.available;
      if(match.mediaIndex!==null && match.mediaIndex>=0) show(match.mediaIndex);
      window.history.replaceState({},'','?variant='+match.id);
    }

    // Sticky add
    var stickyAdd = root.querySelector('[data-sticky-add]');
    if(stickyAdd) stickyAdd.addEventListener('click',function(){ root.querySelector('#iron-form [data-add]').click(); });
    var sDec = root.querySelector('[data-sticky-dec]');
    var sInc = root.querySelector('[data-sticky-inc]');
    if(sDec) sDec.addEventListener('click',function(){ updateQty(qty-1); });
    if(sInc) sInc.addEventListener('click',function(){ updateQty(qty+1); });

    // AJAX add-to-cart
    function ironAddToCart(){
      var opts={};
      root.querySelectorAll('[data-opt-value].is-selected').forEach(function(b){ opts[b.dataset.optPosition]=b.dataset.value; });
      var vMatch=variants.find(function(v){ return v.options.every(function(o,i){ return o===opts[String(i+1)]; }); });
      var vid=vMatch ? String(vMatch.id) : root.querySelector('[data-variant-id]').value;
      if(!vid) return;
      var addBtn=root.querySelector('[data-add]');
      if(addBtn){ addBtn.disabled=true; addBtn.textContent='Adding...'; }
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:Number(vid),quantity:qty})
      })
        .then(function(r){ return r.json(); })
        .then(function(data){
          if(addBtn){ addBtn.disabled=false; addBtn.textContent='ADD TO CART'; }
          if(data.status) return;
          var drawer=document.querySelector('cart-drawer');
          if(!drawer) return;
          return fetch('/?sections=cart-drawer,cart-icon-bubble',{headers:{'Accept':'application/json'}})
            .then(function(r){ return r.json(); })
            .then(function(sections){
              /* 1. Replace cart drawer HTML */
              var html=sections['cart-drawer'];
              if(html){
                var div=document.createElement('div');
                div.innerHTML=html;
                var fresh=div.querySelector('#CartDrawer');
                var target=document.querySelector('#CartDrawer');
                if(fresh&&target) target.innerHTML=fresh.innerHTML;
              }
              /* 2. Update cart icon bubble count */
              var bHtml=sections['cart-icon-bubble'];
              if(bHtml){
                var bEl=document.querySelector('#cart-icon-bubble');
                if(bEl){var bd=document.createElement('div');bd.innerHTML=bHtml;var bf=bd.querySelector('#cart-icon-bubble');if(bf)bEl.innerHTML=bf.innerHTML;}
              }
              /* 3. Open drawer — remove stale is-empty first so CSS shows correctly */
              drawer.classList.remove('is-empty');
              drawer.classList.add('animate','active');
              document.body.classList.add('overflow-hidden');
            });
        })
        .catch(function(){ if(addBtn){ addBtn.disabled=false; addBtn.textContent='ADD TO CART'; } });
    }
    // Intercept via click on button (bypasses any form.submit() confusion) AND form submit as backup
    root.querySelectorAll('[data-add]').forEach(function(btn){
      btn.addEventListener('click',function(e){ e.preventDefault(); ironAddToCart(); });
    });
    if(form){ form.addEventListener('submit',function(e){ e.preventDefault(); }); }

    show(0);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
